import './FormInputsContainer.scss'

const FormInputsContainer = ({ children, type = 'flex', className }) => {
    return <div className={`form-inputs-container form-inputs-container--${type} ${className}`}>{children}</div>
}

export default FormInputsContainer
